import { RouteRecordRaw } from "vue-router";
const routes: RouteRecordRaw[] = [
  {
    path: "weChatAssistant",
    name: "weChatAssistant",
    component: () => import("@/views/weChat-assistant/index.vue")
  }
];
export default routes;